















































// require('./lib/ui/root.js');

import ripple from "../../components/ripple.vue"
import tooltip from "../../components/tooltip.vue"
import gbutton from "../../components/button.vue"
import graph from "../../components/lineGraph.js"

import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { setInterval } from "timers";
import { frontendClient } from "../../lib/client";

@Component({
    components : {
        ripple,
        gbutton,
        graph,
        tooltip,
    },
})
export default class User extends Vue{
    perc:number = 0;
    firstname:string = (frontendClient.userData.fullName).split(" ")[0]

    mounted(){
       this.$emit('scope','home');
    }

    redirect(route,parameters?){
        if(parameters){
            this.$router.replace({ name: route, params: parameters});
        }else{
            this.$router.push({ name: route, params: parameters});
        }
    };

}
